module.exports = __webpack_public_path__ + "media/images/crowdfund2-c24232389ddefec839eb930665453ed1.jpg";